import { useEffect, useState } from "react";
import Modal from "../components/modal";
import Input from "../components/input";
import Button from "../components/button";
import api from "../utils/api";
import ItemReceiverDetails from "./item-receiver-details";
import colors from "../components/colors";

const ItemReceiver = (props) => {
    const [openDocuments, setOpenDocuments] = useState(false);
    const [openPix, setOpenPix] = useState(false);
    const [openHistory, setOpenHistory] = useState(false);
    const [authFile, setAuthFile] = useState(null);
    const [residenceFile, setResidenceFile] = useState(null);
    const [isLoadingUpdateAccount, setIsLoadingUpdateAccount] = useState(false);
    const [pixType, setPixType] = useState(null);
    const [pixKey, setPixKey] = useState(null);

    const existingAuthFile = props?.receiver?.authFile;
    const existingResidenceFile = props?.receiver?.residenceFile;

    const handleAuthFileChange = (event) => {
        setAuthFile(event.target.files[0]);
    };

    const handleResidenceFileChange = (event) => {
        setResidenceFile(event.target.files[0]);
    };

    const handleAccount = () => {

        setIsLoadingUpdateAccount(true);

        api.post('/receiver/account', {
            type: 'pix',
            receiver_id: props?.receiver?.id,
            pix_type: pixType,
            pix_key: pixKey
        }, {
            headers: {
                'Authorization': 'Bearer ' + localStorage.getItem("token")
            }
        })
        .then(res => {
            setIsLoadingUpdateAccount(false);
            props?.getReceivers();
            setOpenPix(false);
        })
        .catch(error => {
            setIsLoadingUpdateAccount(false);
        });

    }

    useEffect(() => {
        if(openPix){
            getAccounts();
        }
    }, [openPix])

    const [isLoadingAccounts, setIsLoadingAccounts] = useState(false);

    const getAccounts = () => {

        setIsLoadingAccounts(true);

        api.get(`/receiver/account/${props?.receiver?.id}`, {
            headers: {
                'Authorization': `Bearer ${localStorage.getItem('token')}`
            }
        })
        .then(function (res) {
            setPixKey(res.data.pix_key);
            setPixType(res.data.pix_type);
            setIsLoadingAccounts(false);
        })
        .catch(err => {
            setIsLoadingAccounts(false);
        });

    }

    const getLabelType = (type) => {
        if(type == 'cpf'){
            return 'Pessoa física';
        } else if(type == 'cnpj'){
            return 'Pessoa jurídica';
        }
    }

    return (
        <>
            <tr className="border-b">
                <td className="py-2 px-4 text-sm text-gray-700">{props?.receiver?.name}</td>
                <td className="py-2 px-4 text-sm text-gray-700">{props?.receiver?.email}</td>
                <td className="py-2 px-4 text-sm text-gray-700">{props?.receiver?.document} ({getLabelType(props?.receiver?.type)})</td>
                {/* <td className="py-2 px-4 text-sm text-blue-700">
                    <span 
                        className="cursor-pointer" 
                        onClick={() => setOpenDocuments(true)}
                    >
                        Documentos
                    </span>
                </td> */}
                <td className="py-2 px-4 text-sm text-blue-700">
                    <span 
                        className="cursor-pointer"
                        onClick={() => setOpenPix(true)}
                    >
                        Chave PIX
                    </span>
                </td>
                <td className="py-2 px-4 text-sm text-blue-700">
                    <span 
                        className="cursor-pointer"
                        onClick={() => setOpenHistory(true)}
                    >
                        Histórico
                    </span>
                </td>
            </tr>
            <Modal
                isOpen={openHistory}
                onClose={() => setOpenHistory(false)}
                title="Histórico pagamentos"
                subtitle={`Recebedor: ${props?.receiver?.name}`}
            >
                <ItemReceiverDetails receiver={props?.receiver?.id} />
            </Modal>
            <Modal
                isOpen={openDocuments}
                onClose={() => setOpenDocuments(false)}
                title="Documentos"
                subtitle={props?.receiver?.name}
            >
                <table className="min-w-full mt-4 border-collapse border border-gray-300">
                    <thead>
                        <tr className="bg-gray-100 border-b">
                            <th className="py-2 px-4 text-left text-sm font-semibold text-gray-700 border border-gray-300">Tipo</th>
                            <th className="py-2 px-4 text-left text-sm font-semibold text-gray-700 border border-gray-300">Status</th>
                            <th className="py-2 px-4 text-left text-sm font-semibold text-gray-700 border border-gray-300">Documento</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr className="border-b">
                            <td className="py-2 px-4 text-sm text-gray-700 border border-gray-300">Autenticação</td>
                            <td className="py-2 px-4 text-sm text-gray-700 border border-gray-300">
                                <span className="inline-flex items-center px-2 py-1 text-xs font-medium text-red-800 bg-red-100 rounded-full">
                                    Pendente
                                </span>
                            </td>
                            <td className="py-2 px-4 text-sm text-gray-700 border border-gray-300">
                                {existingAuthFile ? (
                                    <span className="text-green-600">
                                        {existingAuthFile.name} <span className="text-blue-600 cursor-pointer" onClick={() => document.getElementById('authFileInput').click()}> (Atualizar)</span>
                                    </span>
                                ) : (
                                    <span className="text-red-600 cursor-pointer" onClick={() => document.getElementById('authFileInput').click()}>Selecionar arquivo</span>
                                )}
                                <Input id="authFileInput" type="file" className="hidden" onChange={handleAuthFileChange} />
                            </td>
                        </tr>
                    </tbody>
                </table>
            </Modal>
            <Modal
                isOpen={openPix}
                onClose={() => setOpenPix(false)}
                title="PIX para recebimento"
                subtitle={props?.receiver?.name}
            >
                <div
                    className="text-sm px-4 py-2 mb-4 rounded-[8px] border"
                    style={{
                    backgroundColor: `${colors.primary}20`, // cor com opacidade
                    color: colors.primary,
                    borderColor: colors.primary,
                    }}
                >
                    Tenha certeza de que a chave PIX está correta e que os dados do proprietário da chave batam com o nome e CPF/CNPJ cadastrados. Assim a transferência não ficará pendente.
                </div>
                {isLoadingAccounts ?
                    <>
                        <div className="animate-pulse mt-4">
                            <div className="h-10 bg-gray-300 rounded w-full mb-4"></div>
                            <div className="h-10 bg-gray-300 rounded w-full mb-4"></div>
                            <div className="h-8 bg-gray-300 rounded w-full mb-4"></div>
                        </div>
                    </>
                :
                    <>
                        <Input 
                            value={pixType}
                            onChange={(e) => setPixType(e.target.value)}
                            fullWidth
                            label="Tipo de chave"
                            type="select"
                            options={[
                                {
                                    value: '',
                                    label: 'Selecione'
                                },
                                {
                                    value: 'aleatory',
                                    label: 'Aleatória'
                                },
                                {
                                    value: 'email',
                                    label: 'E-mail'
                                },
                                {
                                    value: 'cellphone',
                                    label: 'Telefone'
                                },
                                {
                                    value: 'cpf',
                                    label: 'CPF'
                                },
                                {
                                    value: 'cnpj',
                                    label: 'CNPJ'
                                }
                            ]}
                        />
                        <div className="mt-4">
                            <Input
                                type={pixType}
                                value={pixKey}
                                onChange={(e) => setPixKey(e.target.value)}
                                fullWidth
                                label="Valor da chave"
                            />
                        </div>
                        <div className="mt-4">
                            <Button 
                                fullWidth
                                disabled={!pixType || !pixKey}
                                isLoading={isLoadingUpdateAccount}
                                onClick={handleAccount}
                            >
                                Salvar
                            </Button>
                        </div>
                    </>
                }
            </Modal>
        </>
    );
};

export default ItemReceiver;
